import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, BoxIcon } from 'lucide-react';
import { Badge } from './Badge';
interface PlaceholderPageProps {
  badgeText: string;
  badgeIcon: React.ReactNode;
  titleStart: string;
  titleAccent: string;
  subtitle: string;
  sections?: {
    icon: BoxIcon;
    title: string;
    description: string;
  }[];
}
export function PlaceholderPage({
  badgeText,
  badgeIcon,
  titleStart,
  titleAccent,
  subtitle,
  sections
}: PlaceholderPageProps) {
  return <div className="w-full" data-id="element-179">
      <section className="relative pt-20 pb-24 overflow-hidden bg-gradient-to-b from-white via-slate-50 to-indigo-50/40" data-id="element-180">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-181">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex flex-col items-center" data-id="element-182">
            <Badge icon={badgeIcon} text={badgeText} data-id="element-183" />
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-black leading-[1.05] tracking-tight mb-6 text-[#0B1020]" data-id="element-184">
              {titleStart}{' '}
              <span className="text-brand-blue" data-id="element-185">{titleAccent}</span>
            </h1>
            <p className="text-lg md:text-xl text-slate-600 max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-186">
              {subtitle}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-187">
              <Link to="/contact" className="bg-brand-blue hover:bg-blue-700 text-white px-8 py-4 rounded-xl font-bold text-lg transition-all shadow-lg shadow-blue-600/20 inline-flex items-center justify-center gap-2 group" data-id="element-188">
                Get in Touch
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-189" />
              </Link>
              <Link to="/" className="bg-white border border-slate-200 hover:bg-slate-50 text-slate-800 px-8 py-4 rounded-xl font-bold text-lg transition-all inline-flex items-center justify-center shadow-sm" data-id="element-190">
                Back to Home
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      {sections && sections.length > 0 && <section className="py-24 bg-white" data-id="element-191">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-192">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-193">
              {sections.map((s, i) => <motion.div key={s.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="p-6 rounded-2xl border border-slate-200 hover:shadow-lg hover:-translate-y-1 transition-all bg-white" data-id="element-194">
                  <div className="w-12 h-12 rounded-xl bg-blue-50 text-brand-blue flex items-center justify-center mb-5" data-id="element-195">
                    <s.icon className="w-6 h-6" data-id="element-196" />
                  </div>
                  <h3 className="text-lg font-bold mb-2" data-id="element-197">{s.title}</h3>
                  <p className="text-slate-600 leading-relaxed text-sm" data-id="element-198">
                    {s.description}
                  </p>
                </motion.div>)}
            </div>
          </div>
        </section>}
    </div>;
}